import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["error", "title", "name", "label", "disabled", "defaultChecked", "required", "vwScale"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef } from "react";
import classnames from "classnames";
import styles from "@/styles/Form.module.scss";
import ErrorMessage from "./ErrorMessage";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SingleCheckboxField = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      error,
      title,
      name,
      label,
      disabled,
      defaultChecked,
      required,
      vwScale
    } = props,
    _props = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(styles.formTitle, {
        [styles.required]: required,
        [styles.vwScale]: vwScale
      }),
      children: title
    }), /*#__PURE__*/_jsxs("div", {
      className: classnames(styles.checkbox, {
        [styles.disabled]: disabled,
        [styles.vwScale]: vwScale
      }),
      children: [/*#__PURE__*/_jsx("input", _objectSpread({
        ref: ref,
        id: `checkbox-${name}`,
        name: name,
        type: "checkbox",
        defaultChecked: defaultChecked,
        disabled: disabled
      }, _props)), /*#__PURE__*/_jsx("label", {
        htmlFor: `checkbox-${name}`,
        className: `${styles.label} ${disabled ? styles.disabled : ""}`,
        tabIndex: "0",
        children: /*#__PURE__*/_jsx("span", {
          children: label
        })
      })]
    }), error && /*#__PURE__*/_jsx(ErrorMessage, {
      msg: error
    })]
  });
});
SingleCheckboxField.displayName = "SingleCheckboxField";
export default SingleCheckboxField;